import { render, staticRenderFns } from "./FormForwarder.vue?vue&type=template&id=505b57d9"
import script from "./FormForwarder.vue?vue&type=script&lang=js"
export * from "./FormForwarder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports